/**
 * Live-черновик формулы через Yjs awareness (не пишется в документ до Enter).
 */

const COLORS = [
  '#38bdf8', '#f472b6', '#a78bfa', '#34d399', '#fbbf24', '#fb7185', '#2dd4bf',
];

export function colorForClientId(clientId) {
  const n = Number(clientId) || 0;
  return COLORS[Math.abs(n) % COLORS.length];
}

/** Локальный фрагмент awareness для таблицы. */
export function buildSheetAwarenessPayload({
  dataKey,
  active,
  sel,
  editing,
  pointTo = null,
  name = '',
}) {
  const payload = {
    dataKey: String(dataKey || 'data'),
    active: active ? { row: active.row, col: active.col } : null,
    sel: sel
      ? {
        r0: sel.r0, r1: sel.r1, c0: sel.c0, c1: sel.c1,
      }
      : null,
    editing: null,
  };
  if (editing) {
    payload.editing = {
      row: editing.row,
      col: editing.col,
      draft: String(editing.draft ?? ''),
      caret: Number.isFinite(editing.caret) ? editing.caret : String(editing.draft ?? '').length,
      pointTo: pointTo && Number.isFinite(pointTo.row) && Number.isFinite(pointTo.col)
        ? { row: pointTo.row, col: pointTo.col }
        : null,
    };
  }
  if (name) payload.name = String(name);
  return payload;
}

export function setLocalSheetAwareness(awareness, sheetPayload) {
  if (!awareness) return;
  const prev = awareness.getLocalState() || {};
  awareness.setLocalState({
    ...prev,
    sheet: sheetPayload || null,
  });
}

export function clearLocalSheetAwareness(awareness) {
  if (!awareness) return;
  const prev = awareness.getLocalState() || {};
  if (!prev.sheet) return;
  const next = { ...prev };
  delete next.sheet;
  awareness.setLocalState(next);
}

/**
 * Чужие черновики/выделения по dataKey.
 * @returns {{ clientId: number, color: string, name: string, sheet: object }[]}
 */
export function listRemoteSheetStates(awareness, dataKey) {
  if (!awareness) return [];
  const key = String(dataKey || 'data');
  const localId = awareness.clientID;
  const out = [];
  awareness.getStates().forEach((state, clientId) => {
    if (clientId === localId) return;
    const sheet = state?.sheet;
    if (!sheet || sheet.dataKey !== key) return;
    out.push({
      clientId,
      color: colorForClientId(clientId),
      name: String(sheet.name || state?.user?.name || ''),
      sheet,
    });
  });
  return out;
}

/** Кто редактирует клетку (кроме себя). */
export function remoteEditorOnCell(remotes, row, col) {
  for (const r of remotes) {
    const ed = r.sheet?.editing;
    if (ed && ed.row === row && ed.col === col) return r;
  }
  return null;
}
